// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1xCkE","option":"styles_option__1jNok","selected":"styles_selected__1K_C4"};